import { API } from "@/lib/api";

export const BOOKING_URL = "https://direct-book.com/properties/bcn1333";

/** Anonymous first-party counter of "Reservar" clicks (no cookies, no personal data). */
export function trackBookingClick(source, lang = "es") {
  const w = window.innerWidth;
  const body = JSON.stringify({
    source,
    page: window.location.pathname,
    lang,
    device: w < 768 ? "mobile" : w < 1024 ? "tablet" : "desktop",
  });
  fetch(`${API}/track/booking-click`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body,
    keepalive: true,
  }).catch(() => {});
}

const pad = (n) => String(n).padStart(2, "0");
export const toISODate = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export function defaultDates() {
  const today = new Date();
  const checkin = new Date(today);
  checkin.setDate(today.getDate() + 1);
  const checkout = new Date(checkin);
  checkout.setDate(checkin.getDate() + 1);
  return { checkin: toISODate(checkin), checkout: toISODate(checkout) };
}

export function buildBookingUrl({ lang = "es", checkin, checkout, adults = 2, children = 0, promo = "" } = {}) {
  const p = new URLSearchParams();
  p.set("locale", lang);
  p.set("currency", "EUR");
  if (checkin) p.set("checkInDate", checkin);
  if (checkout) p.set("checkOutDate", checkout);
  p.set("items[0][adults]", String(adults));
  p.set("items[0][children]", String(children));
  p.set("items[0][infants]", "0");
  if (promo) p.set("promotionCode", promo.trim());
  p.set("trackPage", "yes");
  return `${BOOKING_URL}?${p.toString()}`;
}
